<template>
  <div class="page">
    <div class="banner">
      <!--<img class="banner" src="@/assets/img/news/banner.png" />-->
    </div>
    <div class="content">
      <side-nav :navs="navs" :active="active" @change-nav="changeNav">
        <side-nav-content
          :bread="['新闻资讯', '行业快讯']"
          v-show="active === 0"
        >
          <div class="list">
            <cell-list
              showType="icon"
              :data="list"
              :currentPage="currentPage"
              :totalPage="totalPage"
              @changePage="handleChange"
              @chooseItem="chooseItem"
            />
          </div>
        </side-nav-content>
        <side-nav-content :bread="['新闻资讯', '简讯']" v-show="active === 1">
          <div class="list">
            <cell-list
              showType="text"
              :data="list"
              :currentPage="currentPage"
              :totalPage="totalPage"
              @changePage="handleChange"
              @chooseItem="chooseItem"
            />
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['新闻资讯', '深度报道']"
          v-show="active === 2"
        >
          <div class="list">
            <cell-list
              showType="icon"
              :data="list"
              :currentPage="currentPage"
              :totalPage="totalPage"
              @changePage="handleChange"
              @chooseItem="chooseItem"
            />
          </div>
        </side-nav-content>
      </side-nav>
    </div>
  </div>
</template>
<script>
// import { getList } from "../config/newsDataList";
import SideNav from "../components/sideNav";
import SideNavContent from "../components/sideNavContent";
import CellList from "../components/cellList";
import { getNewsList } from "../api/newsApi";

export default {
  name: "contact",
  components: {
    SideNav,
    SideNavContent,
    CellList
  },
  data() {
    return {
      active: 0,
      navs: [
        { id: 1, name: "行业快讯" },
        { id: 2, name: "简讯" },
        { id: 3, name: "深度报道" }
      ],
      list: [],
      currentPage: 1,
      totalPage: 5
    };
  },
  created() {
    this.active = this.$store.state.newsActive
    this.currentPage = this.$store.state.newsCurrentPage
    console.log("111", this.currentPage)
    this.getCurrentList();
  },
  methods: {
    getCurrentList() {
      const that = this;
      getNewsList(that.navs[that.active].id, that.currentPage).then(res => {
        that.totalPage = res.data.pages;
        that.list = res.data.articles;
      });
    },
    changeNav(index) {
      this.active = index;
      this.getCurrentList();
    },
    handleChange(index) {
      const that = this;
      if (index > 0 && index <= that.totalPage) {
        that.currentPage = index;
        that.getCurrentList();
      }
    },
    chooseItem(index) {
      const that = this;
      // console.log(that.list[index]);
      that.$store.commit("updateNewsClick", { active: that.active, currentPage: that.currentPage })
      that.$router.push("/detail/news/" + that.list[index].id);
    }
  }
};
</script>
<style scoped>
@import "../assets/css/main.css";
.banner {
  width: 100%;
  height: 321px;
  background: url("../assets/img/news/banner.png") center no-repeat;
  margin-bottom: 40px;
}
.list {
  min-height: 500px;
}
</style>
